module.exports = __webpack_public_path__ + "static/pattern-ecac50e5c56c3dbb17c48fef03db3d47.png";